import { createContext, useContext } from 'react';
import type { TimelineGesturesContextT } from '../../types/frame-timeline-v4';
const defaultContext: TimelineGesturesContextT = {
  stage: new EventTarget()
};
export const TimelineGesturesContext = createContext<TimelineGesturesContextT>(defaultContext);
export function useTimelineGestures(): TimelineGesturesContextT {
  return useContext(TimelineGesturesContext);
}